import React from 'react';
import '../pages/css/Home.css';
import '../pages/css/CustomSoftwareDevelopment.css';
import { motion } from 'framer-motion';
import ct1 from '../images/clutch-logo.jpg';
import ct2 from '../images/goodfirms-logo.jpeg';
import ct3 from '../images/agency-spotter-logo.png';
import ct4 from '../images/Google-logo.png';

function ClientTestiminials() {
  const testimonials = [
    {
      title: "Their web development projects are visually stunning and performance-driven.",
      description: "peregrinee delivered a tailored software solution that met all business requirements, increasing process automation by 50% and reducing manual errors by 70%. The team maintained clear and consistent communication throughout the project and was responsive to the client's needs and concerns.",
      name: "James Scott",
      position: "Business Consultant of James Business Solutions",
      img: ct1,
      rating: "5.0/5.0",
      link: "https://clutch.co/profile/peregrinee#reviews"
    },
    {
      title: "The project was delivered on time.",
      description: "Customer satisfaction is gauged through app ratings, reviews, and Net Promoter Scores (NPS), alongside the efficiency of customer support in resolving queries. Operational efficiency is reflected in reduced order processing times, lower error rates, and an optimized cost per user acquisition.Marketing success is measured by user acquisition from campaigns, referral rates, and engagement across social media platforms.",
      name: "James Nguyen",
      position: "CEO at Quantropi Inc.",
      img: ct2,
      rating: "4.9/5.0",
      link: "https://www.goodfirms.co/company/peregrinee"
    },
    {
      title: "Best Software Development Service Provider in India",
      description: "Peregrinee is hands down the best software development service provider in India, offering tailored solutions for businesses of all sizes. Their expertise in cutting-edge technologies, commitment to timely delivery, and exceptional support set them apart. Our experience with Peregrinee was seamless—they delivered beyond expectations and maintained proactive communication throughout.",
      name: "John Windsor",
      position: "Staffing and Recruiting",
      img: ct3,
      rating: "4.8/5.0",
      link: "https://www.agencyspotter.com/peregrinee"
    },
    {
      title: "Our mobile app turned out exactly as envisioned",
      description: "Our mobile app turned out exactly as envisioned.clean design, fast performance, and bug-free experience. The team was communicative and quick to implement feedback. top choice for app development services.",
      name: "Ganesh Pawar",
      position: "Google Business Profile",
      img: ct4,
      rating: "5.0/5.0",
      link: "https://www.google.com/search?gs_ssp=eJzj4tVP1zc0rDQ1T7fILjM1YLRSNagwTjQwMjc3NTS3NEgxSzJOsQIKGZsnWxqZmCWZGxokp6SmeHEVpBalphdl5qWmAgBJUhLJ&q=peregrinee&oq=&gs_lcrp=EgZjaHJvbWUqDwgAEC4YJxivARjHARjqAjIPCAAQLhgnGK8BGMcBGOoCMgkIARAjGCcY6gIyCQgCECMYJxjqAjIJCAMQIxgnGOoCMgkIBBAuGCcY6gIyCQgFECMYJxjqAjIJCAYQIxgnGOoCMgkIBxAjGCcY6gLSAQ0yNzQ1ODY0NjJqMGo3qAIIsAIB8QVSfzgjVnKB2PEFUn84I1Zygdg&sourceid=chrome&ie=UTF-8#lrd=0x3a027751790d6b3d:0x337c9246b710cded,1,,,,"
    },
    {
      description: "We partnered with peregrinee for our website development, and they exceeded expectations. The team was professional, communicative, and delivered a high-quality, user-friendly site. Highly recommended!",
      name: "Vikas Magare",
      position: "Google Business Profile",
      img: ct4,
      rating: "4.7/5.0",
      link: "https://www.google.com/search?gs_ssp=eJzj4tVP1zc0rDQ1T7fILjM1YLRSNagwTjQwMjc3NTS3NEgxSzJOsQIKGZsnWxqZmCWZGxokp6SmeHEVpBalphdl5qWmAgBJUhLJ&q=peregrinee&oq=&gs_lcrp=EgZjaHJvbWUqDwgAEC4YJxivARjHARjqAjIPCAAQLhgnGK8BGMcBGOoCMgkIARAjGCcY6gIyCQgCECMYJxjqAjIJCAMQIxgnGOoCMgkIBBAuGCcY6gIyCQgFECMYJxjqAjIJCAYQIxgnGOoCMgkIBxAjGCcY6gLSAQ0yNzQ1ODY0NjJqMGo3qAIIsAIB8QVSfzgjVnKB2PEFUn84I1Zygdg&sourceid=chrome&ie=UTF-8#lrd=0x3a027751790d6b3d:0x337c9246b710cded,1,,,,"
    },
    {
      description: "Peregrinee transformed our online presence with their outstanding web design and digital marketing strategies. They are very professional and creative. Their SEO and ad strategies brought measurable results fast. Highly recommend for digital growth and brand building.",
      name: "Rimpa Bhunia",
      position: "Google Business Profile",
      img: ct4,
      rating: "4.9/5.0",
      link: "https://www.google.com/search?gs_ssp=eJzj4tVP1zc0rDQ1T7fILjM1YLRSNagwTjQwMjc3NTS3NEgxSzJOsQIKGZsnWxqZmCWZGxokp6SmeHEVpBalphdl5qWmAgBJUhLJ&q=peregrinee&oq=&gs_lcrp=EgZjaHJvbWUqDwgAEC4YJxivARjHARjqAjIPCAAQLhgnGK8BGMcBGOoCMgkIARAjGCcY6gIyCQgCECMYJxjqAjIJCAMQIxgnGOoCMgkIBBAuGCcY6gIyCQgFECMYJxjqAjIJCAYQIxgnGOoCMgkIBxAjGCcY6gLSAQ0yNzQ1ODY0NjJqMGo3qAIIsAIB8QVSfzgjVnKB2PEFUn84I1Zygdg&sourceid=chrome&ie=UTF-8#lrd=0x3a027751790d6b3d:0x337c9246b710cded,1,,,,"
    }
  ];

  return (
    <>
      <motion.section id="testimonials" className="container my-5"
        initial={{ y: 30, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: false, amount: 0.6 }}
        transition={{ duration: 0.8, ease: "easeOut" }}>
        <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
          <div
            className="px-3 fw-bold responsive-heading"
          >
            Here’s what our clients say <span className="highlight-orange">about us</span>
          </div>
        </div>
      </motion.section>

      <section className="container my-5">
        <div className="row g-4">
          {testimonials.map((item, idx) => (
            <motion.div
              key={idx}
              className="col-12 col-md-6 col-lg-4"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: false, amount: 0.4 }}
              transition={{ duration: 0.5, ease: "easeOut" }}>
              <div className="custom-card p-3 h-100">
                <div className="top-left-content mb-3">
                  <h5 className="fw-bold">{item.title}</h5>
                  <p>{item.description}</p>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    <img src={item.img} alt={`profile-${idx + 1}`} className="profile-img" />
                  </a>
                  <div className="profile-info">
                    <div className="profile-name">{item.name}</div>
                    <div className="profile-position">{item.position}</div>
                    <div className="profile-rating">⭐⭐⭐⭐⭐ {item.rating}</div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </>
  );
}

export default ClientTestiminials;
